import { render, staticRenderFns } from "./DeckVideoDetail.vue?vue&type=template&id=5f7a8c42&"
import script from "./DeckVideoDetail.vue?vue&type=script&lang=js&"
export * from "./DeckVideoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports